<section class="customers">
  @if (hasTitle) {
    <h3 class="customers-heading page-description">
      {{'WEBSITE.CUSTOMERS.TITLE' | translate}}
    </h3>
  }

  <app-logo-carousel [images]="images" />
</section>
